import { Col, FormGroup, Label, Row } from "reactstrap";
import SelectWithInput from "../../../Common/SelectWithInput";
import { AvField, AvInput } from "availity-reactstrap-validation";
import CustomSelect from "../../../Common/CustomSelect";
import { getDefaultValueForSelect } from "../../../../helpers/utils";
import React from "react";
import PropTypes from "prop-types";
import CheckboxCollapse from "../../../Common/CheckboxCollapse";
import FormByKpiIndicators from "./FormByKpiIndicators";

const FormByCostTypeRM = ({
  isLoading,
  offer_data,
  isFormSubmit,
  trackers,
  cost,
  suffix,
  events,
  setGroups,
  offer,
}) => {
  const [kpiIndicator, setKpiIndicator] = React.useState(
    cost?.r_m__kpi_indicator
  );
  const [isKpiIndicator, setIsKpiIndicator] = React.useState(
    !!cost?.r_m__kpi_indicator
  );

  const [isCustom, setIsCustom] = React.useState(false);

  const kpi_indicator_options = [
    { label: "Retention", value: "RR" },
    { label: "Conversion", value: "CR" },
    { label: "Event cost", value: "Event_cost" },
    { label: "Return on Ad Spend", value: "ROAS" },
    { label: "CPI", value: "CPI" },
    { label: "Average order value", value: "AOV" },
  ];

  const currency_type_options = [
    { label: "Avg per month", value: "Avg_per_month" },
    { label: "Last date", value: "Last_date" },
  ];

  const handleChangeKPI = val => {
    setKpiIndicator(val.value);
    setGroups(prev => {
      return prev.map(i => {
        if (`|${i.suffix}|` !== suffix) return i;

        return {
          ...i,
          suffix: Math.round(Math.random() * 10000).toString(),
          r_m__kpi_indicator: val.value,
        };
      });
    });
  };

  return (
    <React.Fragment>
      <Row>
        <Col md="6">
          <FormGroup className="mb-3">
            <Label htmlFor="">Revenue model percent:</Label>
            <SelectWithInput
              select_name={"r_m__currency" + suffix}
              options={offer_data.currencies}
              defaultValue={{
                label: cost?.r_m__currency || "USD",
                value: cost?.r_m__currency || "USD",
              }}
              required
              isLoading={isLoading}
              inputOptions={{
                name: "r_m__percent" + suffix,
                placeholder: "Revenue model percent",
                value: cost?.r_m__percent || "",
                type: "number",
                errorMessage: "Revenue model percent field is required!",
                validate: { required: { value: true } },
              }}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup className="mb-3">
            <CheckboxCollapse
              id={"r_m__cohort-days-id" + suffix}
              title="Cohort days"
              defaultChecked={!!cost?.r_m__is_cohort}
            >
              <AvField
                name={"r_m__cohort_days_quantity" + suffix}
                placeholder="Cohort days"
                type="number"
                value={cost?.r_m__cohort_days_quantity || ""}
                className="form-control"
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Please, enter a cohort days",
                  },
                  min: {
                    value: 0,
                    errorMessage: "The cohort cannot be negative",
                  },
                }}
              />
            </CheckboxCollapse>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup className="mb-3">
            <Label htmlFor="">
              Event{" "}
              <span
                className="btn__add-custom-event"
                onClick={() => setIsCustom(prev => !prev)}
              >
                ({!isCustom ? "Add custom event" : "View events"})
              </span>
              :
            </Label>
            {!isCustom ? (
              <CustomSelect
                name={"r_m__events" + suffix}
                isMulti
                options={events}
                placeholder="Select event..."
                classNamePrefix="select2-selection"
                errorMessage="Event field is required!"
                defaultValue={getDefaultValueForSelect(cost?.r_m__events)}
                isLoading={isLoading}
                isFormSubmit={isFormSubmit}
              />
            ) : (
              <CustomSelect
                name={"custom_event_names" + suffix}
                placeholder="Event name..."
                classNamePrefix="select2-selection"
                errorMessage="Event name field is required!"
                isMulti
                creatable
                required
                isFormSubmit={isFormSubmit}
              />
            )}
          </FormGroup>
        </Col>
        {isCustom && (
          <Col md={3}>
            <FormGroup className="mb-3">
              {isCustom && (
                <>
                  <Label htmlFor="">Tracker</Label>
                  <CustomSelect
                    name={"custom_event_tracker" + suffix}
                    options={trackers}
                    defaultValue={trackers[0]}
                    placeholder="Select tracker..."
                    classNamePrefix="select2-selection"
                    errorMessage="Tracker field is required!"
                    required
                    isLoading={isLoading}
                    isFormSubmit={isFormSubmit}
                  />
                </>
              )}
            </FormGroup>
          </Col>
        )}
        <Col md={3}>
          <FormGroup className="mb-3">
            <AvInput
              className={"mr-1"}
              style={{ marginBottom: "10.5px" }}
              type="checkbox"
              name={"unique_events" + suffix}
              value={!!cost?.[`unique_events`] || false}
            />
            <Label check for={"unique_events" + suffix}>
              Is unique
            </Label>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <FormGroup className="mb-3">
            <Label htmlFor="">Currency type:</Label>
            <CustomSelect
              name={"currency_type"}
              options={currency_type_options}
              defaultValue={
                getDefaultValueForSelect(offer?.currency_type) ||
                currency_type_options[0]
              }
              placeholder="Currency type..."
              classNamePrefix="select2-selection"
              errorMessage="Currency type field is required"
              required
              isLoading={isLoading}
              isFormSubmit={isFormSubmit}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <FormGroup className="mb-3">
            <CheckboxCollapse
              id={"r_m__kpi-indicator-checkbox" + suffix}
              title="KPI indicator"
              defaultChecked={!!cost?.r_m__kpi_indicator}
              onChange={val => setIsKpiIndicator(val)}
            >
              <CustomSelect
                name={"r_m__kpi_indicator" + suffix}
                options={kpi_indicator_options}
                defaultValue={getDefaultValueForSelect(
                  cost?.r_m__kpi_indicator
                )}
                placeholder="Select KPI indicator..."
                classNamePrefix="select2-selection"
                errorMessage="KPI indicator field is required"
                onChange={handleChangeKPI}
                required
                isLoading={isLoading}
                isFormSubmit={isFormSubmit}
              />
            </CheckboxCollapse>
          </FormGroup>
        </Col>
        <Col md="6">
          {isKpiIndicator && (
            <FormGroup className="mb-3">
              <CheckboxCollapse
                id={"cohort-days-id" + suffix}
                title="Cohort days"
                defaultChecked={!!cost?.r_m__kpi_is_cohort}
              >
                <AvField
                  name={"r_m__kpi_cohort_days_quantity" + suffix}
                  placeholder="Cohort days"
                  type="number"
                  value={cost?.r_m__kpi_cohort_days_quantity || ""}
                  className="form-control"
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter a cohort days",
                    },
                    min: {
                      value: 0,
                      errorMessage: "The cohort cannot be negative",
                    },
                  }}
                />
              </CheckboxCollapse>
            </FormGroup>
          )}
        </Col>
      </Row>

      {isKpiIndicator && (
        <FormByKpiIndicators
          kpiIndicator={kpiIndicator}
          cost={cost}
          suffix={suffix}
          prefix="r_m"
          isLoading={isLoading}
          isFormSubmit={isFormSubmit}
        />
      )}
    </React.Fragment>
  );
};

FormByCostTypeRM.propTypes = {
  isLoading: PropTypes.any,
  offer_data: PropTypes.any,
  isFormSubmit: PropTypes.any,
  cost: PropTypes.any,
  suffix: PropTypes.string,
  trackers: PropTypes.any,
  events: PropTypes.any,
  setGroups: PropTypes.func,
  offer: PropTypes.any,
};

export default FormByCostTypeRM;
